export var RelationshipToTrust;
(function (RelationshipToTrust) {
    RelationshipToTrust["Trustee"] = "TRUSTEE";
    RelationshipToTrust["Beneficiary"] = "BENEFICIARY";
    RelationshipToTrust["Director"] = "DIRECTOR";
    RelationshipToTrust["ShareholderOfCorporateTrustee"] = "SHAREHOLDER_OF_CORPORATE_TRUSTEE";
})(RelationshipToTrust || (RelationshipToTrust = {}));
//# sourceMappingURL=RelationshipToTrust.js.map